const labels: Record<string, string> = {
  loan: 'Loan Request', individual: 'Applicant details', financial: 'Income and Expenses', bankAccount: 'Bank details',
  individualPricingQuote: 'Quotation', loanAmount: 'Loan amount', loanTerm: 'Repayment dates',
  loanPurpose: 'Loan purpose',
  commencementDate: 'Commencement date', dueDate: 'Final repayment date', customLoanType: 'Payment type',
  numberOfInstallments: 'Number of monthly installments', individualBreakdown: 'Monthly breakdown',
};

/** Include nested field errors, but never walk React Hook Form's DOM references. */
export function individualValidationMessages(errors: unknown, path: string[] = []): string[] {
  if (!errors || typeof errors !== 'object') return [];
  const record = errors as Record<string, unknown>;
  if (typeof record.message === 'string') {
    const label = path.map(key => labels[key] || key.replace(/([a-z])([A-Z])/g, '$1 $2').replace(/^./, value => value.toUpperCase())).join(' → ');
    return [`${label}: ${record.message}`];
  }
  return Object.entries(record).filter(([key]) => !['ref', 'type', 'types'].includes(key))
    .flatMap(([key, value]) => individualValidationMessages(value, [...path, key]));
}
